import { SSOUserTemplateFormFields } from 'es/app/views/system/sso-user-templates/SsoUserTemplates.types';

type FieldName = {
    [K in keyof SSOUserTemplateFormFields]: K;
};

export const SSO_USER_TEMPLATE_FIELD_NAME: FieldName = {
    domain: 'domain',
    defaultFirstName: 'defaultFirstName',
    defaultLastName: 'defaultLastName',
    locale: 'locale',
    formsAuthEnabled: 'formsAuthEnabled',
    accessGroups: 'accessGroups',
};
